export default __webpack_public_path__ + "static/media/ticket.a8599224.svg";